import React from 'react';
import { Spinner } from 'reactstrap'
import './SplashScreen.css';
export const SplashScreen = (props) => {
    return (
        <React.Fragment>
            <div className="splash-screen">
                <div className="splash_logo">
                    <Spinner style={{ width: '5rem', height: '5rem', marginLeft: '-15px', marginTop: '-25px' }} color="info" />
                </div>
            </div>
        </React.Fragment>
    )
}